type ProductReviewRelation = {
  review?: unknown;
};

function isRatedReview(review: unknown): review is { rating: number } {
  return (
    typeof review === "object" &&
    review !== null &&
    "rating" in review &&
    typeof review.rating === "number" &&
    Number.isFinite(review.rating)
  );
}

export function getProductReviewSummary(reviews: ProductReviewRelation[] | null | undefined) {
  const ratings = (reviews ?? [])
    .map((item) => item.review)
    .filter((review): review is { rating: number } => isRatedReview(review))
    .map((review) => review.rating);

  if (!ratings.length) return null;

  return {
    averageRating: Number(
      (ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length).toFixed(1),
    ),
    count: ratings.length,
  };
}
